import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { AcceptDataRequestInviteModal } from '@vivli/features/data-requests/components';
import { AcceptOrgInviteModal } from '@vivli/features/organizations/components';
import { useModalApiContext } from '@vivli/core/infrastructure/context';

export const useAcceptInvitePopupInit = () => {
    const modalApi = useModalApiContext();
    const { pathname } = useLocation();

    const getAcceptOrgInviteModal = () => {
        const orgId = pathname?.split('/')[2];
        modalApi.message(<AcceptOrgInviteModal orgId={orgId} />, { showLogo: true, showBackground: true });
    };

    const getDataRequestInviteModal = () => {
        const dataRequestId = pathname?.split('/')[2];
        const teamMemberId = pathname?.split('/')[3];
        modalApi.message(<AcceptDataRequestInviteModal dataRequestId={dataRequestId} teamMemberId={teamMemberId} />, {
            showLogo: true,
            showBackground: true,
        });
    };

    useEffect(() => {
        if (pathname?.indexOf('/acceptinvite/') >= 0) {
            getAcceptOrgInviteModal();
        }
        if (pathname?.indexOf('/acceptinvitefordatarequest/') >= 0) {
            getDataRequestInviteModal();
        }
    }, [pathname, getAcceptOrgInviteModal, getDataRequestInviteModal]);
};
